import type { Currency } from '@/api/types/public';
import logger from '@/utils/client-logger';
import Cookie from 'js-cookie';

const persistCurrencyNameToCookie = (currency: Currency) => {
  if (currency?.name) {
    Cookie.set('zl-currency', currency.name, { expires: 365, sameSite: 'lax', path: '/' });
  }
};

const persistCurrencyToLocal = (currency: Currency) => {
  if (!currency) return;
  try {
    localStorage.setItem('zl-currency', JSON.stringify(currency));
  } catch (e) {
    logger.error(e);
  }
};

export const persistCurrency = (currency: Currency) => {
  logger.info('setDomainCurrency', currency);
  persistCurrencyNameToCookie(currency);
  persistCurrencyToLocal(currency);
};
